import _ from 'lodash';

import { APP_LANGUAGES } from 'src/constants';

export const dumpCashExchangeData = (data) => {
  const copiedDescriptions = _.cloneDeep(data?.descriptions);

  delete data?.descriptions;

  let payload = { ...data };

  APP_LANGUAGES.forEach((lng) => {
    const findedDescription = copiedDescriptions?.find((item) => item?.language_id === lng.id);

    payload = {
      ...payload,
      descriptions: {
        ...payload.descriptions,
        [lng.id]: {
          address: findedDescription?.address || '',
          city: findedDescription?.city || '',
          country: findedDescription?.country || '',
        },
      },
    };
  });

  return payload;
};
